"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secondaryModalState = exports.default = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ModalState {
  constructor() {
    _defineProperty(this, "_observers", {});
    _defineProperty(this, "_modalPromise", null);
    _defineProperty(this, "_modalResolve", () => {});
    _defineProperty(this, "_modalReject", () => {});
  }
  setModal(modalContent, modalTitle) {
    this._modalPromise = new Promise((resolve, reject) => {
      this._modalResolve = resolve;
      this._modalReject = reject;
      this.modalContent = modalContent;
      this.modalTitle = modalTitle;
      this.publish("SetModal", {
        modalContent,
        modalTitle
      });
    });
    return this._modalPromise;
  }
  closeModal(modalReturnValue, onCloseCb) {
    this.modalContent = null;
    this.modalTitle = "";
    this.publish("CloseModal");
    this._modalResolve(modalReturnValue);
    this.clearPromise();
    onCloseCb && onCloseCb();
  }
  updateModalProps(updatedProps) {
    this.modalTitle = updatedProps.modalTitle || this.modalTitle;
    this.publish("UpdateModalProps", updatedProps);
  }
  clearPromise() {
    this._modalPromise = null;
    this._modalResolve = () => {};
    this._modalReject = () => {};
  }
  subscribe(observer, topics) {
    for (const topic of topics) {
      if (!this._observers[topic]) {
        this._observers[topic] = [];
      }
      if (this._observers[topic].indexOf(observer) === -1) {
        this._observers[topic].push(observer);
      }
    }
  }
  unsubscribe(observer) {
    for (const topic in this._observers) {
      if (this._observers.hasOwnProperty(topic)) {
        const index = this._observers[topic].indexOf(observer);
        if (index !== -1) {
          this._observers[topic].splice(index, 1);
        }
      }
    }
  }
  publish(eventTopic, eventData) {
    if (this._observers.hasOwnProperty(eventTopic)) {
      for (const observer of this._observers[eventTopic]) {
        observer.notify(eventTopic, eventData);
      }
    }
  }
}
const modalState = new ModalState();
var _default = exports.default = modalState;
const secondaryModalState = exports.secondaryModalState = new ModalState();